$(document).ready(function() {
  $('#user_fiscal_country, #user_country').on('change', function() {
    if(
        ($('#user_country').val() === "FR" && ['', 'FR'].includes($('#user_country').val())) ||
          $('#user_fiscal_country').val() === 'FR'
      ) {
      $('#owner_foreigner_tax_exemption').val('');
      $('#owner_foreigner_tax_exemption .container-file-text').html('Choisissez un fichier');
      $('#address_proof_documents').addClass('hidden');
    } else {
      $('#address_proof_documents').removeClass('hidden');
    }
  });
})
